// src/shared/api.js — връзката със сървъра (копие от app.js, Фаза 3).
//
// 401 не импортва auth екрана директно (би създало цикъл api→auth→api):
// обработчикът се ИНЖЕКТИРА. Докато app.js е жив, main.js го връзва към
// legacy renderAuth през моста window.CRM.

let onUnauthorized = null;
export function setUnauthorizedHandler(fn) { onUnauthorized = fn; }

export async function api(path, opts = {}) {
  let res;
  try {
    res = await fetch('/api' + path, {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      ...opts,
    });
  } catch (e) {
    // Паднала връзка: „Failed to fetch" не значи нищо за счетоводител.
    throw new Error('Няма връзка със сървъра — проверете интернета и опитайте пак.');
  }
  if (res.status === 401 && onUnauthorized && onUnauthorized()) {
    throw new Error('Сесията изтече.');
  }
  let data = {};
  try { data = await res.json(); } catch (e) {}
  if (!res.ok) {
    // Кодът се закача към грешката: някои екрани реагират различно на 409
    // („ползван е — деактивирай вместо това") и не бива да го гадаят по текста.
    const err = new Error(data.error || httpText(res.status));
    err.status = res.status;
    // Цялото тяло — някои отговори носят списък (грешките от проверката
    // преди файла за Конто), който екранът показва.
    err.data = data;
    throw err;
  }
  return data;
}

// Преводът на голите кодове (Фаза А.2). Сървърните съобщения (data.error) са
// наши, на български и по-конкретни — те ПЕЧЕЛЯТ. Долното се вижда само
// когато тяло няма: срив в обработчик, прокси грешка, паднал контейнер.
function httpText(status) {
  if (status === 403) return 'Нямате права за това действие.';
  if (status === 404) return 'Записът не е намерен — може някой да го е изтрил.';
  if (status >= 500) return 'Възникна грешка при записа — опитайте пак.';
  return 'Възникна грешка.';
}
